/**
 * 言語設定の mutaions
 */
const mutations = {

  /**
   * 言語設定を変更します
   */
  lang: (state, payload) => {
    state.value = payload;
  }

};

export { mutations as default };
